var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"bigBody"},[_c('div',{staticClass:"smallBody",style:('width:' + ( _vm.width*8) + 'rem')},[_c('div',{staticClass:"smallHead"},[_vm._v(_vm._s(_vm.width)+"%")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }